<template>
  <span class="wrapper">
    <slot />
  </span>
</template>

<style scoped>
.wrapper {
  @apply relative z-0 inline-flex shadow-sm rounded-md;
}

.wrapper :deep(> *) {
  @apply relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500;

  &:first-child {
    @apply rounded-l-md;
  }

  &:not(:first-child) {
    @apply -ml-px;
  }

  &:last-child {
    @apply rounded-r-md;
  }

  &.-primary {
    @apply bg-indigo-600 hover:bg-indigo-700 text-white;
  }

  &.-sync {
    @apply bg-blue-100;

    &:hover {
      @apply bg-blue-400 text-white;
    }
  }
}
</style>
